import React, { useEffect } from 'react';
import { SearchBox } from '../../../app/common/sharedComponents/SearchBox';
import { ISelectedOption } from '../../../app/@types/searchBox';
import { useTranslation } from 'react-i18next';
import { handleOptionClickUtil } from '../../../app/common/sharedComponents/SearchBox/utils';
import { useSearchUser } from '../../../app/common/hooks/useSearchUser';
import { TaggedsView } from '../../../app/common/sharedComponents/TaggedsView';
import { convertTaggedUsersInitialState } from '../../../app/myAudit/utils';

interface ISelfAssessmentTaggedUsersProps {
  initialTaggedUsers?: ISelectedOption[];
  isDisabled?: boolean;
  onTaggedUsersChange: (taggedUsers: ISelectedOption[]) => void;
}

export function SelfAssessmentTaggedUsers ({
  initialTaggedUsers = [],
  isDisabled = false,
  onTaggedUsersChange,
}: ISelfAssessmentTaggedUsersProps) {
  const { t } = useTranslation();
  const normalizedInitial = convertTaggedUsersInitialState(initialTaggedUsers);
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
  } = useSearchUser(normalizedInitial);

  useEffect(() => {
    onTaggedUsersChange(selectedOptions);
    // Only sync when the tag list changes; callback is stable via useCallback in parent.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);

  function handleInputChange (value: string) {
    setSearchText(value);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
      setSearchText('');
    }
  }

  function clearSearch () {
    setSearchText('');
  }

  function removeTag (tagIndex: number) {
    const filteredRemovedTag = selectedOptions.filter(
      (_, index) => index !== tagIndex
    );
    setSelectedOptions(filteredRemovedTag);
  }

  if (isDisabled) {
    return <TaggedsView selectedOptions={selectedOptions} />;
  }

  return (
    <SearchBox
      handleInputChange={handleInputChange}
      searchBoxOptions={searchBoxOptions}
      handleOptionClick={handleOptionClick}
      selectedOptions={selectedOptions}
      searchTextName={searchText}
      clearSearch={clearSearch}
      placeholderText={t(
        'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
      )}
      label={t('COMMON.MY_AUDIT.LABELS.TAGGED')}
      showTags={true}
      removeTag={removeTag}
      disabled={isDisabled}
    />
  );
}
